/**
 * De enum die de 2D webservices bevat.
 */
export enum Webservice2DType {
  WMS = "wms",
  WMTS = "wmts",
  GEOJSON = "geojson",
  VECTOR = "vector",
  IMAGE = "image"
}

/**
 * De enum die de 3D webservices bevat.
 */
export enum Webservice3DType {
  WMTS = "wmts",
  GEOJSON = "geojson",
  TILES3D = "3Dtiles"
}
